import { Alert, AlertIcon, Box, Code, Spinner, Text } from '@chakra-ui/react';
import { useFetchGitsHarRecalls } from '../../../../state/server-side/queries/carolive-v3';
import { formatDate } from '../../../../utils/helpers';
import { PerformRecall } from './perform-recall';
import { getAgentName } from './helpers';

export const GitsHarRecallsInfo = ({ order }) => {
	const { data, isLoading, isError, error } = useFetchGitsHarRecalls(order.vin, {
		enabled: !!order.vin && order.idMarca === 2,
	});

	/** @type {GitsHarRecall[]} */
	const recalls = !data ? null : data;

	const vin = order.vin;
	if (!vin || !recalls || order.idMarca !== 2) return null;

	if (isLoading) {
		return <Spinner size={'lg'} />;
	}

	if (isError) {
		const isVinError = error?.cause?.message === 'Invalid VIN';
		if (isVinError) {
			return (
				<Box>
					<Text fontWeight={'bold'} fontSize={'lg'}>
						Atentie!
					</Text>
					<Text>
						Aceasta masina are seria de caroserie eronata:{' '}
						<Code py={1} px={2}>
							{vin}
						</Code>
					</Text>
				</Box>
			);
		}
		return null;
	}

	if (recalls.length === 0) {
		return (
			<Box maxW={{ base: '100%', xl: '50%' }}>
				<Alert status={'info'}>
					<AlertIcon />
					Seria <Code>{vin}</Code> nu a fost gasita in baza HAR de campanii active. Solicita verificare la
					departamentul de garantii.
				</Alert>
			</Box>
		);
	}

	return (
		<Box maxW={{ base: '100%', xl: '50%' }}>
			<Text fontWeight={'bold'} fontSize={'lg'}>
				Recall-uri HAR
			</Text>
			{/* <pre>{JSON.stringify(recalls, null, 2)}</pre> */}
			<Box display={'flex'} flexDir={'column'} gap={2}>
				{recalls.map(recall => {
					if (recall.efectuat && !recall.doneAt) {
						return (
							<Text key={recall.id} p={4} bgColor={'gray.700'}>
								Campania <Code>{recall.denumire}</Code> a fost efectuata ✅
							</Text>
						);
					}

					if (recall.doneAt) {
						return (
							<Text key={recall.id} p={4} bgColor={'gray.700'}>
								Recall <Code>{recall.denumire}</Code> a fost efectuat la data de{' '}
								<strong>{formatDate(recall.doneAt, 'dd.MM.yyyy')}</strong> de catre{' '}
								<strong>{getAgentName(recall.doneBy)}</strong> ✅
							</Text>
						);
					}

					return (
						<Box
							key={recall.id}
							display={'flex'}
							flexDir={'column'}
							alignItems={'flex-start'}
							gap={2}
							p={4}
							bgColor={'red.900'}
						>
							<Text>
								Auto inclus in campania <Code>{recall.denumire}</Code>. Valabilitate campanie:{' '}
								<strong>{formatDate(recall.dataInceput, 'dd.MM.yyyy')}</strong> -{' '}
								<strong>{formatDate(recall.dataSfarsit, 'dd.MM.yyyy')}</strong>
							</Text>
							<PerformRecall recall={recall} orderId={order.id} />
						</Box>
					);
				})}
			</Box>
		</Box>
	);
};

/**
 * @typedef {object} GitsHarRecall
 * @property {string} id
 * @property {string} cod
 * @property {string} denumire
 * @property {string} vin
 * @property {string} dataInceput
 * @property {string} dataSfarsit
 * @property {boolean} efectuat
 * @property {string} importedAt
 * @property {string | null} [doneAt]
 * @property {string | null} [doneBy]
 * @property {string | null} [transferredAt]
 * @property {string} updatedAt
 * @property {string} createdAt
 */
